import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/forms/icon.component';
import ManualShell from './manual.shell';
import { MANUAL_SECTIONS, searchManual } from './content';

export default function ManualIndexPage() {
  const [query, setQuery] = useState('');
  const hits = useMemo(() => (query.trim().length >= 2 ? searchManual(query) : []), [query]);
  const searching = query.trim().length >= 2;

  return (
    <ManualShell>
      <div className="mb-6">
        <h1 className="fw-bolder fs-2x mb-1">Manual de Raptor</h1>
        <div className="text-muted fs-7">
          Cómo funciona cada pantalla y de dónde sale cada número. Escrito para QA y para el equipo
          de operación.
        </div>
      </div>

      {/* Buscador */}
      <div className="card shadow-sm border-0 rounded-4 mb-6">
        <div className="card-body p-5">
          <div className="position-relative">
            <span className="position-absolute translate-middle-y top-50 ms-4">
              <Icon icon="ki-magnifier" size="fs-3" className="text-gray-500" />
            </span>
            <input
              type="text"
              className="form-control form-control-solid form-control-lg ps-13"
              placeholder="Buscar en todo el manual: buzón, bypass, UTC, permisos, 603…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            {query !== '' && (
              <button
                type="button"
                className="btn btn-icon btn-sm position-absolute translate-middle-y top-50 end-0 me-3"
                onClick={() => setQuery('')}
              >
                <Icon icon="ki-cross" size="fs-3" className="text-gray-500" />
              </button>
            )}
          </div>

          {searching && (
            <div className="mt-5">
              <div className="text-muted fs-8 mb-3">
                {hits.length === 0
                  ? 'Sin resultados.'
                  : `${hits.length} ${hits.length === 1 ? 'resultado' : 'resultados'}`}
              </div>
              {hits.map((h) => (
                <Link
                  key={`${h.sectionSlug}-${h.topicId}`}
                  to={`/manual/${h.sectionSlug}#${h.topicId}`}
                  className="d-block rounded-3 p-4 mb-2 bg-light text-decoration-none hover-scale"
                >
                  <div className="d-flex align-items-center mb-1">
                    <span className="badge badge-light-primary fs-8 me-2">{h.sectionTitle}</span>
                    <span className="fw-bold text-gray-900 fs-7">{h.topicTitle}</span>
                  </div>
                  <div className="text-muted fs-8">{h.snippet}…</div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Secciones */}
      {!searching && (
        <div className="row g-5">
          {MANUAL_SECTIONS.map((s) => (
            <div key={s.slug} className="col-md-6 col-xxl-4">
              <Link
                to={`/manual/${s.slug}`}
                className="card shadow-sm border-0 rounded-4 h-100 text-decoration-none hover-scale"
              >
                <div className="card-body p-5 d-flex flex-column">
                  <div className="d-flex align-items-center mb-3">
                    <span className="symbol symbol-40px me-3">
                      <span className="symbol-label bg-light-primary">
                        <Icon icon={s.icon} size="fs-2" type="primary" />
                      </span>
                    </span>
                    <span className="fw-bold fs-5 text-gray-900">{s.title}</span>
                  </div>
                  <div className="fs-7 text-gray-700 lh-lg flex-grow-1">{s.summary}</div>
                  {s.audience && (
                    <div className="text-muted fs-8 mt-3 pt-3 border-top border-gray-200">
                      {s.audience}
                    </div>
                  )}
                  <div className="text-muted fs-8 mt-2">
                    {s.topics.length} {s.topics.length === 1 ? 'tema' : 'temas'}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </ManualShell>
  );
}
